<div class="fit-grid-tile-container">
  <ng-content select="[mgFitGridTile]"></ng-content>
</div>
